angular.module('webcomm').config(['$routeProvider', function ($routeProvider) {
    $routeProvider
        .when('/main/:mode*?', {
            controller: 'MainController',
            templateUrl: 'app/main/main.html' 
        })
        .when('/:mode?', {
            controller: 'LoginController',
            templateUrl: 'app/login/login.html'
        })
        .otherwise({
            redirectTo: '/'
        });
}]);